module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "customer-data-package-setting"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("下单时客户资料包校验")]), _vm._v(" "), _c('div', {
    staticClass: "setting-item"
  }, [_c('div', [_c('span', [_c('span', [_vm._v("设计师/导购必须上传指定资料包后，才能一键下单与传单？")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "是",
      "inactive-text": "否",
      "active-value": 0,
      "inactive-value": 1
    },
    model: {
      value: (_vm.customerDataPackage.status),
      callback: function($$v) {
        _vm.$set(_vm.customerDataPackage, "status", $$v)
      },
      expression: "customerDataPackage.status"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "apply-scope-setting"
  }, [_c('span', [_vm._v("适用范围：")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.customerDataPackage.applyScope),
      callback: function($$v) {
        _vm.$set(_vm.customerDataPackage, "applyScope", $$v)
      },
      expression: "customerDataPackage.applyScope"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("对全部人校验")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("只对要审的订单进行校验")])], 1)], 1)]), _vm._v(" "), (!_vm.customerDataPackage.status) ? _c('div', {
    staticClass: "customer-data-package-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.customerDataPackage.conditionList,
      "border": "",
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "informationPackTypeName",
      "label": "资料包类型",
      "align": "center",
      "min-width": "200",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "min-width": "125"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('span', [_vm._v("前台是否展示")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "设置是否对设计师/导购下单时展示该项资料",
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning",
          staticStyle: {
            "cursor": "pointer"
          }
        })])]
      },
      proxy: true
    }, {
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-checkbox', {
          model: {
            value: (row.frontDisplay),
            callback: function($$v) {
              _vm.$set(row, "frontDisplay", $$v)
            },
            expression: "row.frontDisplay"
          }
        })]
      }
    }], null, false, 1332986208)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "必填校验",
      "min-width": "125"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-checkbox', {
          on: {
            "change": function($event) {
              return _vm.handleRequiredVerificationChange(row)
            }
          },
          model: {
            value: (row.requiredVerification),
            callback: function($$v) {
              _vm.$set(row, "requiredVerification", $$v)
            },
            expression: "row.requiredVerification"
          }
        })]
      }
    }], null, false, 4008695779)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "资料包提交维度",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-radio-group', {
          model: {
            value: (row.submissionDimension),
            callback: function($$v) {
              _vm.$set(row, "submissionDimension", $$v)
            },
            expression: "row.submissionDimension"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 0
          }
        }, [_vm._v("按客户")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_vm._v("按品类")])], 1)]
      }
    }], null, false, 399547927)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "min-width": "125"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('span', [_vm._v("关联到订单")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "文件上传后关联到订单附件",
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning",
          staticStyle: {
            "cursor": "pointer"
          }
        })])]
      },
      proxy: true
    }, {
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-checkbox', {
          model: {
            value: (row.relatedOrder),
            callback: function($$v) {
              _vm.$set(row, "relatedOrder", $$v)
            },
            expression: "row.relatedOrder"
          }
        })]
      }
    }], null, false, 1301993129)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "min-width": "380"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('span', [_vm._v("资料包提交方式")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "【手工上传附件】需要设计师/导购下单前上传对应文件，【在线办理】目前仅支持客户合同报价在线确认最终报价",
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning",
          staticStyle: {
            "cursor": "pointer"
          }
        })])]
      },
      proxy: true
    }, {
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "submission-methods-row"
        }, [_c('el-checkbox-group', {
          model: {
            value: (row.submissionMethodList),
            callback: function($$v) {
              _vm.$set(row, "submissionMethodList", $$v)
            },
            expression: "row.submissionMethodList"
          }
        }, _vm._l((_vm.getAvailableSubmissionMethods(row)), function(method) {
          return _c('el-checkbox', {
            key: method.value,
            attrs: {
              "label": method.value
            }
          }, [_vm._v("\n                  " + _vm._s(method.label) + "\n                ")])
        }), 1), _vm._v(" "), _vm._l((_vm.getRowActions(row)), function(action) {
          return _c('el-button', {
            key: action.key,
            style: (action.style || {
              marginLeft: '8px'
            }),
            attrs: {
              "type": action.type || 'text',
              "size": action.size || 'mini'
            },
            on: {
              "click": function($event) {
                return _vm.handleRowAction(action, row)
              }
            }
          }, [_vm._v("\n                " + _vm._s(action.label) + "\n              ")])
        })], 2)]
      }
    }], null, false, 23946616)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('span', [_vm._v("特例名单")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "设置在名单中的账号将不校验对应的资料包项是否必传",
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning",
          staticStyle: {
            "cursor": "pointer"
          }
        })])]
      },
      proxy: true
    }, {
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "special-case-list-container"
        }, [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": _vm.getSpecialCaseListText(row.specialCaseList)
          }
        }, [_c('span', {
          staticClass: "special-case-text"
        }, [_vm._v("\n                  " + _vm._s(_vm.getSpecialCaseListText(row.specialCaseList)) + "\n                ")])]), _vm._v(" "), _c('el-button', {
          style: ({
            padding: '0 5px'
          }),
          attrs: {
            "size": "medium",
            "type": "text",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleSpecialCaseSetting(row)
            }
          }
        })], 1)]
      }
    }], null, false, 2068172641)
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('submission-category-dialog', {
    attrs: {
      "title": (_vm.categoryDialogRow && _vm.categoryDialogRow.informationPackTypeName) || '',
      "visible": _vm.categoryDialogVisible,
      "category-options": _vm.categoryOptions,
      "submission-configs": _vm.getActiveSubmissionConfigs(_vm.categoryDialogRow),
      "initial-data": _vm.getCategoryDialogInitialData(_vm.categoryDialogRow)
    },
    on: {
      "close": _vm.handleCloseCategoryDialog,
      "confirm": _vm.handleConfirmCategoryDialog
    }
  }), _vm._v(" "), _c('PermissionSettings', {
    attrs: {
      "visible": _vm.permissionDialogVisible
    },
    on: {
      "close": _vm.handleClosePermissionDialog
    }
  }), _vm._v(" "), _c('ContractConfirmConfigDialog', {
    attrs: {
      "visible": _vm.configDialogVisible,
      "config-data": _vm.contractConfirmConfigData,
      "org-no": _vm.currentUser ? _vm.currentUser.orgNo : '',
      "org-id": _vm.currentUser ? _vm.currentUser.orgId : ''
    },
    on: {
      "update:visible": function($event) {
        _vm.configDialogVisible = $event
      },
      "close": _vm.handleCloseConfigDialog,
      "confirm": _vm.handleConfirmConfig
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd9a580c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/customerDataPackageSetting.vue
// module id = 2421
// module chunks = 68